import styled from 'styled-components';

export const DropZoneCustomStyled = styled.div`
  .dropZone-container {
    position: relative;
    .file-preview {
      position: absolute;
      top: 60%;
      right: 50%;
      transform: translate(50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100;
    }
  }
`;
